const getKey = () => {
  const protoFree = window.location.href.replace(/^https?:\/\//, "");
  if (protoFree.startsWith("localhost")) return "localhost";
  if (protoFree.indexOf("-") === -1) return "pks";
  return protoFree.split(".")[0].split("-")[1];
};
//https://www.transit.land/operators
const settings = {
  localhost: {
    name: "Localhost",
    operators: [
      { name: "Localhostin liikenne", value: 66660000 },
      { name: "Nobinainen", value: 66220000 },
      { name: "Helsingin Businesliikennee", value: 66120000 },
      { name: "Ei tiedossa", value: 0 },
    ],
  },
  pks: {
    name: "PKS",
    operators: [
      { name: "Pohjolan Liikenne", value: 60000 },
      { name: "Nobina", value: 220000 },
      { name: "Helsingin Bussiliikenne", value: 120000 },
    ],
  },
  turku: {
    name: "Turku",
    operators: [
      { name: "Jalon Liikenne", value: 60000 },
      { name: "TuKL", value: 80000 },
      { name: "Savonlinja", value: 110000 },
      { name: "Turkubus", value: 160000 },
      { name: "Muurinen", value: 180000 },
      { name: "Nyholm", value: 200000 },
      { name: "Nobina", value: 220000 },
      { name: "Turun Citybus", value: 270000 },
      { name: "V-S Bussipalvelut", value: 550000 },
      //{name: "Vainio", value: 670000},
      //{name: "Länsilinjat", value: 700000}
    ],
  },
  /*
  jkl: {
    name: "Jyväskylä",
    operators: [{ name: "Ei valittavissa", value: 0 }],
  },
  */
  lahti: {
    name: "Lahti",
    operators: [
      { name: "Koiviston auto", value: 67410000 },
      { name: "Vekka Group", value: 69570000 },
    ],
  },
  kuopio: {
    name: "Kuopio",
    operators: [
      { name: "Pohjola liikenne", value: 60000 },
      { name: "Koiviston auto", value: 67410000 }, //fake id
    ],
  },
};

const key = getKey();
const operators = settings[key].operators;
const name = settings[key].name;
export { key, operators, name };
